import type { RumEvent } from "@datadog/browser-rum";

const oauthCallbackParameters = ["code", "state", "session_state", "iss"];

function stripOAuthParameters(value: string): string {
  const parameters = value.slice(1).split("&");
  const remainingParameters = parameters.filter(
    (parameter) => !oauthCallbackParameters.includes(new URLSearchParams(parameter).keys().next().value ?? "")
  );

  return remainingParameters.length === parameters.length
    ? value
    : remainingParameters.length
      ? `${value[0]}${remainingParameters.join("&")}`
      : "";
}

function stripOAuthCallbackParameters(value: string): string {
  const url = new URL(value);

  url.search = stripOAuthParameters(url.search);
  url.hash = stripOAuthParameters(url.hash);

  return url.toString();
}

export function redactOAuthCallbackParameters(event: RumEvent): boolean {
  if (event.view) {
    event.view.url = stripOAuthCallbackParameters(event.view.url);

    if (event.view.referrer) {
      event.view.referrer = stripOAuthCallbackParameters(event.view.referrer);
    }
  }

  if (event.type === "resource") {
    event.resource.url = stripOAuthCallbackParameters(event.resource.url);
  }

  return true;
}
